<template>
  <span :class="`pdl-label px-1 py-25 text-xs font-medium leading-normal ${kindClass}`">
    <!-- @slot Use for the label's content. -->
    <slot />
    <pdl-button
      v-if="isDismissible"
      text
      icon-only
      label="Close"
      icon="close"
      class="pdl-label__close-button"
      xsmall
      @click="dismiss"
    />
  </span>
</template>

<script>
import {PdlButton} from '@pedal/pdl-button';

export default {
  name: 'PdlLabel',
  components: {PdlButton},
  props: {
    /**
     * Sets the visual of the label.
     */
    kind: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'prominent', 'positive', 'important', 'critical'].includes(value),
    },
    /**
     * Adds a close button to dismiss the label.
     */
    isDismissible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    kindClass() {
      const classList = {
        default: 'bg-gray-10 text-gray-100',
        prominent: 'bg-blue-10 text-blue-140',
        positive: 'bg-green-10 text-green-140',
        important: 'bg-orange-10 text-orange-140',
        critical: 'bg-red-10 text-red-140',
      };
      return classList[this.kind];
    },
  },
  methods: {
    dismiss() {
      /**
       * Emitted when the close button is clicked.
       */
      this.$emit('dismiss');
    },
  },
};
</script>

<style lang="scss">
@import 'Label.scss';
</style>
